import { section } from "@/glow";
import { animateStandard, shouldAnimate } from "@/lib/animation";

section("grid", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateGrid = animateStandard(this.container);
    }
  },

  onUnload() {
    this.animateGrid?.destroy();
  },
});
